import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { couponsClient } from "@core/clients";
import { Coupon } from "@core/types";

const useGetCouponMutation = (options?: UseMutationOptions<Coupon | null, any, string>) =>
  useMutation(async (code) => {
    if (couponsClient) {
      const coupon = await couponsClient.getCoupon(code);
      return coupon;
    }

    throw new Error("couponsClient not implemented");
  }, options);

export default useGetCouponMutation;
